<template>
  <Modal
    :show="true"
    :title="$t('common.switch_company')"
    :width="500"
    vertical-position="center"
    @close="emit('close')"
  >
    <SelectInput
      v-model="selectedCompany"
      :items="companies"
      key-label="label"
      key-value="id"
      show-search
      @change="changeCompany"
    />
  </Modal>
</template>

<script setup>
import Modal from '@/Components/Modal.vue'
import SelectInput from '@/Components/common/SelectInput.vue'
import { useRoute } from '@/composables/route'
import { useForm, usePage } from '@inertiajs/vue3'
import { computed, ref } from 'vue'
const { useI18n } = await import('vue-i18n')
const { t } = useI18n()

const emit = defineEmits(['close'])

const user = usePage().props._user
const selectedCompany = ref(user.active_company?.id)
const form = useForm({})

const companies = computed(() => {
  const nonSupportCompanies = []
  const supportAccessCompanies = []

  usePage().props._companies.forEach((company) => {
    company.label = company.name

    if (company.deactivated) {
      company.label += ` (${t('company.inactive')})`
    }

    if (company.is_support_access) {
      company.label += ' (' + t('common.support_access') + ')'
      supportAccessCompanies.push(company)
    } else {
      nonSupportCompanies.push(company)
    }
  })

  nonSupportCompanies.sort((a, b) => a.label.localeCompare(b.label))
  supportAccessCompanies.sort((a, b) => a.label.localeCompare(b.label))

  return [
    ...nonSupportCompanies,
    {
      label: '--- ' + t('common.companies_with_support_access') + ' ---',
      disabled: true,
    },
    ...supportAccessCompanies,
  ]
})

const changeCompany = async (company) => {
  form.post(
    useRoute('companies.setActive', {
      company,
    }),
  )
  emit('close')
}
</script>
